import React from "react";
import { Route } from "react-router-dom";
import ExternalFlow from "./ExternalFlow";

export default [<Route path="/auth/" component={ExternalFlow} />];
